import {useTranslation} from 'react-i18next';
import {Globe, HandCoins, PlaneLanding} from 'lucide-react';
import {useSummary} from 'context/summary/useSummary';
import {EsimInfoCardItem} from './EsimInfoCardItem';
import {useCustomTheme} from 'context/customTheme';

export const EsimInfoCard = () => {
  const {t} = useTranslation();
  const {data: summary} = useSummary();
  const country = summary?.location?.country?.name;
  const {finalTheme} = useCustomTheme();

  const iconColor = finalTheme.colors.branding.icons;

  return (
    <div className="p-4 bg-[var(--background-secondary)] rounded-2xl">
      <ul className="flex flex-col gap-6">
        {country && (
          <EsimInfoCardItem
            icon={<Globe size={20} color={iconColor} />}
            title={t('esim.manage.info.stay_connected_title')}
            description={t('esim.manage.info.stay_connected_description', {country})}
          />
        )}
        <EsimInfoCardItem
          icon={<HandCoins size={20} color={iconColor} />}
          title={t('esim.manage.info.avoid_roaming_title')}
          description={t('esim.manage.info.avoid_roaming_description')}
        />
        <EsimInfoCardItem
          icon={<PlaneLanding size={20} color={iconColor} />}
          title={t('esim.manage.info.plan_activates_title')}
          description={t('esim.manage.info.plan_activates_description')}
        />
      </ul>
    </div>
  );
};
